import siteCheckApi from '../../api/siteCheck.api'
const state = {
	checkWordData: [],
	singleListWordData: {},
	checkXenusData: {},
	lastDiagnoseTime: '',
}
const getters = {
	getXenusLinkData: state => {
		let data = []
		state.checkXenusData && state.checkXenusData.data && state.checkXenusData.data.forEach(item => {
			data.push(item.url)
		})
		return data
	},
	getXenusDetailData: state => (url) => {
		let obj = {}
		obj = state.checkXenusData.data.find(item => {
			return item.url === url
		})
		return obj
	},
	getDiagnoseNum: state => (type) => {
		let length = 0
		switch (type) {
			case 'word':
				state.checkWordData.forEach(item => {
					length += item.count
				})
				break
			case 'xenus':
				state.checkXenusData.forEach(item => {
					length += item.count
				})
				break
		}
		return length
	},
	getCurDataByPageId: state => (id, type) => {
		let obj = {}
		switch (type) {
			case 'word':
				state.checkWordData.forEach(item => {
					if (item.pageId === id) {
						obj = item
					}
				})
				break
			case 'xenus':
				state.checkXenusData.forEach(item => {
					obj = item.pageId === id && item
				})
				break
		}
		return obj
	},
	getAllCheckWord: (state) => {
		let str = '',
			arr = []
		state.checkWordData.forEach(item => {
			arr = [...arr, ...item.arr]
		})
		let strArr = arr.sort((a, b) => {
			return b.length - a.length
		})
		strArr = strArr.filter((ele, index, self) => {
			return self.indexOf(ele) === index
		})
		str = strArr.join('@')
		return str
	},
	handleWordData: (state) => (result) => {
		let arr = []
		let count = 0
		result.forEach((item, i) => {
			let list = {}
			list.index = i + 1
			list.pageId = item.pageId
			list.pageName = item.pageName
			list.htmlName = item.htmlName
			list.count = item.work ? item.work.length : 0
			count += list.count
			list.arr = []
			if (item.work) {
				item.work.forEach(i => {
					list.arr.push(i.keyword)
				})
			}
			arr.push(list)
		})
		return arr
	},
}
const mutations = {
	setDiagnoseState (state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state[key] = data[key]
			}
		}
	},
}
const actions = {
	checkWord ({
		state
	}, params) {
		return siteCheckApi.checkWord({
			projId: params.projId || state.projId,
			domainUrl: params.domainUrl
		})
	},
	deadLinks ({
		state
	}, params) {
		return siteCheckApi.deadLinks(params)
	},
	getDeadLinks ({
		state
	}, params) {
		return siteCheckApi.getDeadLinks({
			projectId: params.projectId || state.projId,
			...params
		})
	},
	getLastWord ({
		state
	}) {
		return siteCheckApi.getLastWord({
			projId: state.projId
		})
	},
	getlastXenus ({
		state
	}) {
		return siteCheckApi.getlastXenus({
			projectId: state.projId
		})
	},
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
